import { render } from "./SummaryMetricsPanel.vue?vue&type=template&id=170436e6&ts=true"
import script from "./SummaryMetricsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryMetricsPanel.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/realtime/components/SummaryMetricsPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "170436e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('170436e6', __exports__)) {
    api.reload('170436e6', __exports__)
  }
  
  module.hot.accept("./SummaryMetricsPanel.vue?vue&type=template&id=170436e6&ts=true", () => {
    api.rerender('170436e6', render)
  })

}


export default __exports__